/**
 * Parsing the raw evidence string the audit agent produced.
 *
 * An evidence item that declares its `kind` is answered from that typed field
 * by the caller. This module handles only the kindless case — bare text stored
 * in an issue block — where the string itself is all there is: whether it
 * looks like a DOM probe rather than something a client should read, and
 * stripping the prompt-control tags the model wrapped its prose in.
 */

// Values that look like selectors or DOM probes read as technical.
const TECHNICAL_VALUE =
  /^(?:querySelector(?:All)?\(|document\.|css=|xpath=|\/\/|main[#.]|\[[\w-]+(?:[=\]])|#[\w-]+(?:\s|$))/;
const AGENT_WRAPPER_TAG =
  /<\/?(?:action|finding|rationale|recommendation|recommended[_-]?action|recommendedAction|summary|title)>/gi;

/** Whether a kindless evidence string reads as audit output, not prose. */
export function readsAsTechnicalValue(value: string): boolean {
  return TECHNICAL_VALUE.test(value.trim());
}

/** The same text with the model's own control tags removed. */
export function withoutAgentWrapperTags(value: string): string {
  return value.replace(AGENT_WRAPPER_TAG, "").trim();
}
